// extracted by mini-css-extract-plugin
export default {"overlay":"EditeSale_overlay__UT5nC","title":"EditeSale_title__ee2LT","div":"EditeSale_div__I3Y7u","buttonClose":"EditeSale_buttonClose__h6KkX","alert":"EditeSale_alert__uhCYV"};